import React from "react";

function Games() {
  return (
    <div className="p-6 text-center">
      <h2 className="text-3xl font-bold mb-4">🎮 Fun Mini-Games</h2>
      <div className="grid md:grid-cols-3 gap-4 justify-center">
        <div className="bg-blue-300 p-6 rounded-xl text-xl font-bold hover:scale-105 transform transition cursor-pointer">🐍 Snake Game</div>
        <div className="bg-pink-300 p-6 rounded-xl text-xl font-bold hover:scale-105 transform transition cursor-pointer">🧠 Memory Match</div>
        <div className="bg-green-300 p-6 rounded-xl text-xl font-bold hover:scale-105 transform transition cursor-pointer">🔢 Math Riddles</div>
      </div>
    </div>
  );
}

export default Games;
